// extracted by mini-css-extract-plugin
module.exports = {"total_inverters":"total_inverters--3XXv5","map":"map--3REkM"};